export interface IMinimizedAudioMaterialProps {
    onDragEnd?: () => void;
    disabled?: boolean;
}

export const MIN_AUDIO_MATERIAL_DRAG_TYPE = 'MIN_AUDIO_MATERIAL_DRAG_TYPE';
